import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var Mail = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.117 15.427H1.882A1.884 1.884 0 010 13.545V2.455C0 1.417.844.573 1.882.573h20.236C23.155.573 24 1.416 24 2.455v11.09a1.885 1.885 0 01-1.883 1.882zM1.882 1.955a.5.5 0 00-.5.5v11.09a.5.5 0 00.5.5h20.236a.5.5 0 00.5-.5l-.002-11.09a.5.5 0 00-.499-.5H1.882z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 9.051a.694.694 0 01-.367-.106L.784 2.135a.69.69 0 11.733-1.17l10.484 6.58L22.485.964a.69.69 0 11.734 1.17l-10.85 6.81a.695.695 0 01-.368.106z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.103 15.094a.69.69 0 01-.435-1.228L9.64 6.612a.691.691 0 01.87 1.075l-8.971 7.254a.694.694 0 01-.435.153zM22.897 15.094a.69.69 0 01-.435-.154l-8.97-7.252a.69.69 0 11.869-1.075l8.97 7.253a.69.69 0 01-.434 1.228z",
    fill: "currentColor"
  }));
});
Mail.displayName = 'Mail';

export { Mail, Mail as default };
